import React, { useState, useEffect } from 'react';
import { Button, TextField, IconButton } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import Swal from 'sweetalert2';
import { createAlumniSpeak, updateAlumniSpeak, deleteAlumniSpeak } from '../../services/getAdminApi';
import { getAlumniSpeaks } from '../../services/getAllApi';

const AlumniSpeak = () => {
  const [alumniSpeaks, setAlumniSpeaks] = useState([]);
  const [formData, setFormData] = useState({
    student_name: '',
    company_name: '',
    description: '',
    student_photo: null,
    company_logo: null,
    status: '1',
  });
  const [editingId, setEditingId] = useState(null);
  const [fileName, setFileName] = useState({
    student_photo: '',
    company_logo: '',
  });

  useEffect(() => {
    fetchAlumniSpeaks();
  }, []);

  const fetchAlumniSpeaks = async () => {
    try {
      const response = await getAlumniSpeaks();
      setAlumniSpeaks(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      Swal.fire('Error', 'Failed to fetch alumni speaks', 'error');
    }
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      setFormData({
        ...formData,
        [name]: files[0],
      });
      setFileName({
        ...fileName,
        [name]: files[0].name, // Update file name
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSave = async () => {
    if (!formData.student_name || !formData.company_name || !formData.description) {
      Swal.fire('Validation Error', 'Please fill all required fields', 'error');
      return;
    }

    const payload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value) payload.append(key, value);
    });

    try {
      if (editingId !== null) {
        const confirmEdit = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to update this alumni speak?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, update it!',
        });

        if (confirmEdit.isConfirmed) {
          console.log("p",formData)
          await updateAlumniSpeak(editingId, formData).then((res)=>{
            console.log("REs",res)
            if(res.status===200){
              Swal.fire('Success', 'Alumni speak updated successfully', 'success');
            }
          })
        
        }
      } else {
        await createAlumniSpeak(payload).then((res)=>{
          if(res.status===201){
            Swal.fire('Success', 'Alumni speak created successfully', 'success');
          }
        })
      
      }

      setFormData({
        student_name: '',
        company_name: '',
        description: '',
        student_photo: null,
        company_logo: null,
        status: '1',
      });
      setFileName({
        student_photo: '',
        company_logo: '',
      });
      setEditingId(null);
      document.getElementById("file-upload").value = "";
      document.getElementById("company-logo").value = "";
      fetchAlumniSpeaks();
    } catch (error) {
      Swal.fire('Error', 'Failed to save alumni speak', 'error');
    }
  };

  const handleEdit = (alumniSpeak) => {
    Swal.fire({
      title: 'Edit Alumni Speak',
      text: 'Do you want to edit this alumni speak?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, edit',
    }).then((result) => {
      if (result.isConfirmed) {
        setEditingId(alumniSpeak.id);
        setFormData({
          student_name: alumniSpeak.student_name,
          company_name: alumniSpeak.company_name,
          description: alumniSpeak.description,
          student_photo: null,
          company_logo: null,
        });
        setFileName({
          student_photo: alumniSpeak.student_photo.slice(-10),
          company_logo: alumniSpeak.company_logo.slice(-10),
        });
      }
    });
  };

  const handleDelete = async (id) => {
    const confirmDelete = await Swal.fire({
      title: 'Are you sure?',
      text: 'This action will delete the alumni speak permanently!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
    });

    if (confirmDelete.isConfirmed) {
      try {
        await deleteAlumniSpeak(id);
        Swal.fire('Success', 'Alumni speak deleted successfully', 'success');
        fetchAlumniSpeaks();
      } catch (error) {
        Swal.fire('Error', 'Failed to delete alumni speak', 'error');
      }
    }
  };

  return (
    <div>
      <div className="dashboard-heading-div">
        <p>Manage Alumni Speaks</p>
      </div>

      <div className="editing-container">
        <div>
          <h2 className="editing-container-heading">
            {editingId !== null ? 'Edit Alumni Speak' : 'Create Alumni Speak'}
          </h2>

          <div className="editing-container-form">
            <div className="editing-container-input-div">
              <label>Student Name:</label>
              <input
                name="student_name"
                value={formData.student_name}
                onChange={handleInputChange}
                required
                placeholder="Enter Student Name"
              />
            </div>

            <div className="editing-container-input-div">
              <label>Company Name:</label>
              <input
                name="company_name"
                value={formData.company_name}
                onChange={handleInputChange}
                required
                placeholder="Enter Company Name"
              />
            </div>

            <div className="editing-container-input-div">
              <label>Description:</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                required
                placeholder="Enter Description"
              />
            </div>

            <div className="editing-container-input-div">
              <label>Student Photo:</label>
              <label htmlFor="file-upload" className="file-upload-btn">
                <i className="bx bx-cloud-upload"></i> {fileName.student_photo || 'Choose File'}
              </label>
              <input
                className="file-upload"
                id="file-upload"
                type="file"
                name="student_photo"
                accept="image/*"
                onChange={handleInputChange}
              />
            </div>

            <div className="editing-container-input-div">
              <label>Company Logo:</label>
              <label htmlFor="company-logo" className="file-upload-btn">
                <i className="bx bx-cloud-upload"></i> {fileName.company_logo || 'Choose File'}
              </label>
              <input
                className="file-upload"
                id="company-logo"
                type="file"
                name="company_logo"
                accept="image/*"
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>
        <button variant="contained" color="primary" onClick={handleSave}>
          {editingId !== null ? 'Update' : 'Save'} <i className="bx bx-send"></i>
        </button>
      </div>

      <div className="table-container-registered-alumni">
        <table>
          <thead>
            <tr>
              <th>Student Name</th>
              <th>Company Name</th>
              <th>Description</th>
              <th>Student Photo</th>
              <th>Company Logo</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {alumniSpeaks.map((alumniSpeak) => (
              <tr key={alumniSpeak.id}>
                <td>{alumniSpeak.student_name}</td>
                <td>{alumniSpeak.company_name}</td>
                <td>{alumniSpeak.description}</td>
                <td>
                  {alumniSpeak.student_photo && (
                    <img
                      src={`${"https://console.fbsedu.in/storage/app/"}/${alumniSpeak.student_photo}`}
                      alt="Student Photo"
                      style={{ width: 50, height: 50 }}
                    />
                  )}
                </td>
                <td>
                  {alumniSpeak.company_logo && (
                    <img
                      src={`${"https://console.fbsedu.in/storage/app/"}/${alumniSpeak.company_logo}`}
                      alt="Company Logo"
                      style={{ width: 50, height: 50 }}
                    />
                  )}
                </td>
                <td>
                  <IconButton color="primary" onClick={() => handleEdit(alumniSpeak)}>
                    <Edit />
                  </IconButton>
                  <IconButton color="error" onClick={() => handleDelete(alumniSpeak.id)}>
                    <Delete />
                  </IconButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AlumniSpeak;
